import { render, staticRenderFns } from "./proportionOfIncomingCustomers.vue?vue&type=template&id=0e006e62&scoped=true&"
import script from "./proportionOfIncomingCustomers.vue?vue&type=script&lang=js&"
export * from "./proportionOfIncomingCustomers.vue?vue&type=script&lang=js&"
import style0 from "./proportionOfIncomingCustomers.vue?vue&type=style&index=0&id=0e006e62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e006e62",
  null
  
)

export default component.exports